// Build a JS property-access expression like "data.device.hardwaremodel"
// or 'data.device["setheaderbrowseraccept-ch"]' from a dotted ValuePath.
// Lowercases all segments to match the cloud's JSON casing, then uses
// bracket notation for segments that are not valid JS identifiers.
export function buildDataAccessExpression(valuePath) {
    const segments = valuePath.toLowerCase().split('.');
    return 'data' + segments.map(seg =>
        /^[a-zA-Z_$][a-zA-Z0-9_$]*$/.test(seg) ? `.${seg}` : `["${seg}"]`
    ).join('');
}
